const sliderOptions = Object.freeze({
	controls: false,
	navPosition: "bottom",
	autoplayButtonOutput: false,
	preventActionWhenRunning: true,
	preventScrollOnTouch: "auto",
	freezable: false,
	gutter: 32,
	onInit: onTinySliderInit,
	controlsText: ["➤", "➤"],
	arrowKeys: true,
	speed: 500,
	responsive: {768: {controls: true}},
});
const resizeEvent = new Event("resize");
let timeout;

/**
 * Initializes any existing slider components
 *
 * @param {string} sel The selector for a slider
 */
export function initSliders(sel) {
	const tns = window.tns;
	if (!tns) {
		return;
	}
	const sliders = document.querySelectorAll(sel);

	for (const slider of sliders) {
		tns(Object.assign({}, sliderOptions, {container: slider}));
	}
}

/**
 * Do whatever needs to be done when initializing a slider
 */
function onTinySliderInit() {
	if (document.readyState === "complete") {
		dispatch();
	} else {
		document.addEventListener("DOMContentLoaded", dispatch);
		timeout = setTimeout(dispatch, 10000);
	}
}

/**
 * Dispatch a reflow event so that Tiny-slider applies its responsive
 * layout like it's supposed to
 */
function dispatch() {
	if (timeout) {
		clearTimeout(timeout);
		timeout = 0;
	}
	document.removeEventListener("DOMContentLoaded", dispatch);

	dispatchEvent(resizeEvent);
}
